import { useSetAtom } from 'jotai';
import { agencySellerAtom } from '../../atoms';

export const useAgencySellerDataUpdater = () => useSetAtom(agencySellerAtom);
